import { SchemaCRUD } from '@/components/crud/SchemaCRUD';

const Users = () => {
	return (
		<SchemaCRUD
			entity="users"
			title="Usuários"
			description="Gerenciar usuários do sistema"
			apiEndpoint="v1/users"
		/>
	);
};

export default Users;
